const Resources = {

    table_headers: [
        { 
          text: 'Name',
          align: 'start',
          value: 'name',
          type: 'link',
        },
        { 
            text: 'Questions',
            value: 'question_counter'
        },
        { 
            text: 'Responses',
            value: 'responses',
            type: 'linkExt',
        },
    ],
    table_headers_answers: [
        { 
            text:     '#',
            align:    '',
            value:    ''
        },
        {
            text:   'Question',
            value:  'question'
        },
        // {
        //     text: 'Answers',
        //     value: 'answers'
        // },
        {
            text:   'Question Type',
            value:  'question_type'
        },
        {
            text:   'Response Type',
            value:  'response_type'
        },
        {
            text:   'Status',
            value:  '',
        },
        {
            text: 'Actions',
            value: 'actions'
        }
    ],

    question_types: [
        {
            id:     1,
            name:   'Equipment/Appearance'
        },
        {
            id:     2,
            name:   'Management Professionalism/Response'
        },
        {
            id:     3,
            name:   'Staff Professionalism/Appearance'
        },
        {
            id:     4,
            name:   'Supplies'
        },
        {
            id:     5,
            name:   'Work Quality'
        },
    ],

    response_types: [
        {
            id:     1,
            name:   'Multiple choice'
        },
        {
            id:     2,
            name:   'Yes/No'
        },
        {
            id:     3,
            name:   'Free comment'
        },
    ],

    breadcrumb:[
        {
            name: 'Home',
            href: '/',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'QC',
            href: '#',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Surveys',
            href: '/qc-surveys',
            arrow: "",
        },
    ],

}

export default Resources;